import { View } from '@shared/components/View';
import { MBEmptyListPlaceholder } from '@shared/components/list';
import { i18n } from '@shared/util/i18n';

export function MBGIFEmptyResults() {
  return (
    <View fill center paddingBottom={2}>
      <MBEmptyListPlaceholder
        title={i18n('chat.input.plusButton.gifSearchEmptyTitle')}
        description={i18n('chat.input.plusButton.gifSearchEmptyDescription')}
        image={{ uri: 'https://i.giphy.com/media/qQdL532ZANbjy/giphy.gif' }}
      />
    </View>
  );
}
